import { useEffect } from 'react';

/**
 * 复刻 demo 的进场动画：对作用域内的 .reveal 元素做 IntersectionObserver，
 * 进入视口后添加 .on（demo 的 <script> 中同一逻辑）。
 */
export default function useReveal(rootSelector: string) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof IntersectionObserver === 'undefined') {
      return undefined;
    }

    const root = document.querySelector(rootSelector);
    if (!root) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('on');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    const targets = Array.from(root.querySelectorAll('.reveal'));
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [rootSelector]);
}
